import { createPinia } from "pinia";
import { createPersistedState } from "pinia-plugin-persistedstate";

// ストアを使用するためのピニアのインスタンスを作成します
export const pinia = createPinia();

// ストアのインポート
import "./authStore";
import "./articleStore";
import "./roleStore";

pinia.use(
  createPersistedState({
    storage: window.sessionStorage,
    paths: ["articles", "isLogin", "authToken", "payload", "role"],
  })
);
